import InfiniteScroll from 'react-infinite-scroll-component';
import { Button, Row } from 'antd';
import React, { useState } from 'react';
import SearchResultCard, { SkeletonResultCard } from './SearchResultCard';
import noResultsIllustration from '../assets/images/not-found.svg';
import errorIllustration from '../assets/images/no-content.svg';

function ResultsList({
  results = [],
  scrollableTargetId = undefined,
  loading = false,
  error = false,
  onReset = () => {},
}) {
  const SCROLL_AMOUNT = 10;
  const [currentScroll, setCurrentScroll] = useState(SCROLL_AMOUNT);
  const noResults = !results?.length;

  if (loading) {
    return (
      <Row
        id={'search-results-container'}
        className={'search-results-container '}
      >
        {Array.from(Array(5)).map((_, i) => (
          <SkeletonResultCard key={i} />
        ))}
        <SkeletonResultCard />
      </Row>
    );
  }

  if (error) {
    return (
      <div className='grid-center h-full txt-center pd-10 pd-top-40'>
        <img src={errorIllustration} alt='No results' className='w-130' />
        <h2 className='sb-blue-900 gBold fs-20'>There was an issue...</h2>
        <p className='sb-blue-700 gSemiBold fs-16 max-w-230'>
          Something went wrong when searching. Please try again.
        </p>
        <Button
          className='sb-blue-500 hover:sb-blue-700 grey-border-200 hover:grey-border-300 br8 fs-16 h-fit gBold pd-top-10 pd-bottom-10 pd-left-20 pd-right-20'
          ghost
          onClick={() => window.location.reload()}
        >
          Refresh
        </Button>
      </div>
    );
  }

  if (noResults) {
    return (
      <div className='grid-center h-full txt-center pd-10 pd-top-40'>
        <img src={noResultsIllustration} alt='No results' className='w-130' />
        <h2 className='sb-blue-900 gBold fs-20'>No results found</h2>
        <p className='sb-blue-700 gSemiBold fs-16 max-w-230'>
          Try changing your search term or resetting the selected filters
        </p>
        <Button
          className='sb-blue-500 hover:sb-blue-700 grey-border-200 hover:grey-border-300 br8 fs-16 h-fit gBold pd-top-10 pd-bottom-10 pd-left-20 pd-right-20'
          ghost
          onClick={onReset}
        >
          Reset Search
        </Button>
      </div>
    );
  }

  return (
    <Row
      id={'search-results-container'}
      className={'search-results-container '}
    >
      <InfiniteScroll
        dataLength={currentScroll}
        next={() => setCurrentScroll((prev) => prev + SCROLL_AMOUNT)}
        hasMore={currentScroll < results.length}
        scrollThreshold={
          0.6 /* fraction scrolled down of the total height of the container with the current visible data */
        }
        scrollableTarget={scrollableTargetId}
        style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
        loader={<SkeletonResultCard />}
      >
        {results.slice(0, currentScroll).map((data) => (
          <SearchResultCard
            key={`fishery-result-${data.public_id}`}
            fisheryId={data.public_id}
            name={data.name}
            address={`${data.city}, ${data.postcode}`}
            thumbnail={data.images?.[0]}
            data={data}
            bookable={data.is_bookable}
            initialIsFavourite={data.is_favourite}
          />
        ))}
      </InfiniteScroll>
    </Row>
  );
}

export default ResultsList;
